/**
 * DASHBOARD-HEATMAP-GOLLAC-SKELETON.WIDGET
 * Skeleton adapté au mode Gollac de dashboard-heatmap.widget.tsx : contrairement à la
 * matrice standard (nombreuses colonnes par filtre), le tableau Gollac n'affiche qu'une
 * seule colonne de valeur ("écart") par ligne de topic — un skeleton simple en rangées
 * label + pourcentage, avec un reflet qui balaie.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const ROW_COUNT = 10

export default function DashboardHeatmapGollacSkeletonWidget() {
  return (
    <div className="rel" style={{ padding: "20px 30px", overflow: "hidden" }}>
      <Skeleton width={220} height={18} style={{ marginBottom: 24 }} />

      {Array.from({ length: ROW_COUNT }).map((_, i) => (
        <div key={i} className="flex items-center" style={{ gap: 16, marginBottom: 16 }}>
          <Skeleton width={280} height={14} />
          <div style={{ flex: 1 }} />
          <Skeleton width={90} height={22} borderRadius={11} />
        </div>
      ))}

      <SkeletonShine />
    </div>
  )
}
